/** Thrown only for invariant-breaking input the codec cannot losslessly represent — see error policy in normalizer/types.ts. */
export class NormalizerFatalError extends Error {
  readonly path: string;

  constructor(message: string, path: string) {
    super(`${message} (at ${path})`);
    this.name = 'NormalizerFatalError';
    this.path = path;
  }
}
